import React from "react";
import "./style.css";

const Refund = () => {
  return (
    <>
      {/* ---------- Banner Section ---------- */}
      <section className="refund-banner">
        <div className="container">
          <h1 className="banner-title">Refund & Cancellation Policy</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span className="arrow">→</span>
            <span>Refund & Cancellation Policy</span>
          </div>
        </div>
      </section>

      {/* ---------- Refund Policy Section ---------- */}
      <section className="refund-section">
        <div className="container">

          <h1 className="main-title">Refund & Cancellation Policy</h1>

          <h3 className="sub-title">Omeswara Refund Policy</h3>

          <p>
            A chargeback shall mean a transaction that is uncollectible and returned
            to service provider / Omeswara by user / payee or acquiring bank for a
            refund to the concerned payer / user due to any of the following reasons:
          </p>

          <h3 className="sub-title">What Information do we collect??</h3>

          <p><strong>(A)</strong> Any payment which the user / payer refuses to honour or demands a refund of because the products purchased or the delivery thereof, was not as promised or was defective, deficient, incomplete and / or unsatisfactory.</p>

          <p><strong>(B)</strong> Any payments by a user / payer using the services, which is returned by the acquiring bank for any reason whatsoever.</p>

          <p><strong>(C)</strong> Any charge / debit arising out of any alleged hacking breach of security or encryption.</p>

          <p><strong>(D)</strong> Any transaction that is unsuccessful.</p>

          <p>
            Due to the rapid movement of funds, once a payment is initiated, it may
            not be possible to retract it. The user must notify their bank and
            Omeswara immediately for any chargeback attempt.
          </p>

          <p>
            It may be possible to retract a payment in case of UPI/NB/CC/DC if the
            instruction is given within the prescribed time.
          </p>

          <p>
            In a chargeback situation regarding a product or service for which payment
            has not yet been made to the payee, the user must resolve the issue within
            45 days.
          </p>

          <p>
            If unresolved within 45 days, Omeswara may credit the disputing payer’s
            account directly for the disputed amount.
          </p>

          <p>
            Omeswara shall pass on any received chargeback amount to the user within 7 days.
          </p>

          <h3 className="sub-title">Chargeback Methods</h3>

          <p><strong>(a)</strong> Deduction of the relevant amount or any part thereof from any amounts to the payee.</p>
          <p><strong>(b)</strong> Billing the concerned party for the relevant amount or any part thereof.</p>

        </div>
      </section>
    </>
  );
};

export default Refund;
